module.exports = __webpack_public_path__ + "img/auditions.91e91241.png";